import React, {PropsWithChildren} from 'react';
import {Button} from '@mui/material';

export interface EditButtonsProps {
    onSetEditing: (editing: boolean) => void;
    editing?: boolean;
    canSave?: boolean;
    disabled?: boolean;
    onDelete?: () => void;
    onSave?: () => void;
}

export const EditButtons = ({
                                children,
                                editing, canSave, disabled,
                                onSetEditing, onDelete, onSave
                            }: EditButtonsProps & PropsWithChildren) => {

    if ((editing ?? onSave !== undefined) && !disabled && onSave) {
        return (
            <div className="edit-buttons">
                <Button onClick={onSave} disabled={!(canSave ?? true)} variant="contained" color="primary">Save</Button>
                <Button onClick={() => onSetEditing(false)} variant="contained" color="inherit">Cancel</Button>
            </div>
        );
    }

    return (
        <div className="edit-buttons">
            <Button onClick={() => onSetEditing(true)} variant="contained" color="primary" disabled={disabled}>Edit</Button>
            {children}
            <Button onClick={onDelete} variant="contained" color="secondary" disabled={disabled}>Delete</Button>
        </div>
    );
};
